import React from 'react'

import PressHeaderCell from './PressHeaderCell'

const PressHeader = props => {
  return (
    <table className={`post-table`}>
      {props.width <= 800 ? (
        <tbody>
          <tr className="post-table-row">
            <PressHeaderCell {...props}>Filter By</PressHeaderCell>
            <td></td>
          </tr>
          <tr className="post-table-row">
            <PressHeaderCell {...props} onAction={props.toggleFilter} id="award">
              Award
            </PressHeaderCell>
            <PressHeaderCell {...props} onAction={props.toggleFilter} id="media">
              Media
            </PressHeaderCell>
          </tr>
        </tbody>
      ) : (
        <tbody>
          <tr className="post-table-row">
            <PressHeaderCell {...props}>Filter By</PressHeaderCell>
            <PressHeaderCell {...props} onAction={props.toggleFilter} id="award">
              Award
            </PressHeaderCell>
            <PressHeaderCell {...props} onAction={props.toggleFilter} id="media">
              Media
            </PressHeaderCell>
          </tr>
        </tbody>
      )}
    </table>
  )
}

export default PressHeader
